import React, { useState } from 'react';
import YayineviSecici from '../YayineviSecici';
import { kapakTasarimlari } from './sabitler';
import { LGS_MODU } from '../../lib/ortam';
import { secimSinifi, SECILI_ISARET, sinavSuresiGecerli, SINAV_SURESI_MIN, SINAV_SURESI_MAX, SINAV_ADI_MAX } from './yardimcilar';

// ============================================================
// ÇIKTI bölümü (Faz C, 2026-09-03): yalnız çıktıya dair üç seçenek + deneme kapağı.
// Kaldırılan format kontrolleri (kağıt, sütun, yerleşim, header/footer, kapak/OMR
// toggle, kitapçık türü, görsel boyutu, çözüm alanı) BURAYA GERİ GELMEZ — tek
// yerleşim ÖSYM.
// Sade akış (2026-09-03, kullanıcı): seçenekler belirgin seçim düğmesi; native
// checkbox erişilebilirlik için `sr-only` kalır (etiket = düğme).
//
// YAYINEVİNE VERİLECEK (2026-09-15, kullanıcı kararı — yayınevi DB listesi):
//   * Açıkken yayınevi seçimi ZORUNLU (YayineviSecici, listede yoksa "+ Yeni") +
//     isteğe bağlı "Birim fiyat (₺)". Yayınevi seçilmeden PDF kilitli (`teslimKilidi`).
//   * PDF İNDİRME satış kaydını sunucuda yazar: fiyat girildiyse "satış", boşsa
//     "fiyat bekliyor" teslimi (Satış Arşivi'nden fiyatlandırılır). Önizleme /
//     yazdırma kayıt YAZMAZ ama başka yayınevine satılmış soru kuralı hepsinde geçerli.
//   * Havuz paneli KALKTI: sonuç şeridi "Satış Arşivi’nde gör" ile arşive gider.
//   * Kapak "Kurum adı" seçilen yayınevi adıyla ön-dolar (Basim.js `yayineviSec`).
// ============================================================
// OKUL KAPAĞI (2026-10-08, kullanıcı kararı): okul listeden seçilir (DB, /api/okul); seçili
// okul kapakta logo + okul adı + "MEBİ AYARINDA" mührü basar, kurum kutusunun yerini alır.
// MEBİ logosu sistemde YOK. Logo texlive `gorseller` kanalına SVG olarak gider: yüklenen
// PNG/JPG/SVG tarayıcıda en uzun kenarı 1000 px PNG'ye çevrilir ve SVG'ye sarılır.
// ÖĞRENME KANITI (yalnız konu ürünü): 9/10/11. sınıf işlenen konular denemesi kapak türü.
// "KANIT" tek başına bir yayın adı — ekranda ve kapakta kullanılmaz.
const LOGO_PX = 1000;
export function logoSvgOlustur(dosya) {
  return new Promise((coz, reddet) => {
    const url = URL.createObjectURL(dosya);
    const img = new Image();
    img.onload = () => {
      const k = Math.min(1, LOGO_PX / Math.max(img.naturalWidth || 1, img.naturalHeight || 1));
      const w = Math.max(1, Math.round((img.naturalWidth || LOGO_PX) * k));
      const h = Math.max(1, Math.round((img.naturalHeight || LOGO_PX) * k));
      const c = document.createElement('canvas');
      c.width = w; c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      URL.revokeObjectURL(url);
      const png = c.toDataURL('image/png');
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">`
        + `<image width="${w}" height="${h}" xlink:href="${png}"/></svg>`;
      coz(btoa(svg));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reddet(new Error('Görsel okunamadı (PNG, JPG ya da SVG olmalı)')); };
    img.src = url;
  });
}

function OkulLogo({ apiUrl, authFetch, okul, setOkul }) {
  const [durum, setDurum] = useState('');
  const yukle = async (e) => {
    const dosya = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!dosya || !okul) return;
    setDurum('Yükleniyor…');
    try {
      const logo = await logoSvgOlustur(dosya);
      const r = await authFetch(`${apiUrl}/api/okul/${okul.id}`, { method: 'PATCH', body: JSON.stringify({ logo_svg: logo }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.basarili) throw new Error(d.hata || 'Logo kaydedilemedi');
      setOkul({ ...okul, logo_var: true });
      setDurum('');
    } catch (err) {
      setDurum(err.message);
    }
  };
  return (
    <>
      <label className="px-2 py-1.5 rounded border border-blue-300 bg-blue-50 text-blue-800 text-xs font-semibold hover:bg-blue-100 cursor-pointer"
        title="Okul logosu: PNG, JPG ya da SVG. Kapakta en üstte basılır; okul kaydında saklanır.">
        <input data-okul-logo type="file" accept="image/png,image/jpeg,image/svg+xml" className="sr-only" onChange={yukle} />
        {okul.logo_var ? '✓ Logo · değiştir' : '🖼 Logo yükle'}
      </label>
      {durum && <span data-okul-logo-durum className="text-[11px] text-red-700 font-semibold">{durum}</span>}
    </>
  );
}

function SecimKutusu({ checked, onChange, title, children, ek = '' }) {
  return (
    <label className={`${secimSinifi(checked, ek)} inline-flex items-center gap-1.5 cursor-pointer select-none`} title={title}>
      <input type="checkbox" className="sr-only" checked={checked} onChange={onChange} />
      <span>{checked ? SECILI_ISARET : ''}{children}</span>
    </label>
  );
}

// SORU BANKASI (2026-10-11): `soruBankasi` → kapak satırı (okul/kurum/sınav adı/tarih/süre/Öğrenme Kanıtı)
// ve A/B gizlenir — kitap kimliği SoruBankasiPaneli'nden gelir; akıllı dizgi + sayfa hedefi kalır.
export default function CiktiPaneli({
  tamDenemeAktif, soruBankasi = false, genelDeneme = false,
  cevapAnahtariGoster, setCevapAnahtariGoster,
  cozumDosyasiAyri, setCozumDosyasiAyri,
  yayineviTeslim, setYayineviTeslim,
  apiUrl, authFetch, yayinevi, onYayineviSec, birimFiyat, setBirimFiyat, teslimKilidi,
  yayineviSonuc, setYayineviSonuc, onSatisArsivineGit, denemeKayit = null,
  kayitAdet = 0, onYalnizKaydet = null, kayitYaziliyor = false,
  kurum, setKurum, sinavTarihi, setSinavTarihi, sinavSuresi = '', setSinavSuresi = () => {},
  sinavAdi = '', setSinavAdi = () => {}, kapakTasarim = '', setKapakTasarim = () => {},
  okul = null, setOkul = () => {}, kanit = { acik: false, sinif: 9, uygulama: '' }, setKanit = () => {},
  icerikSinif = null, kanitKapali = false, abKitapcik = false, kitapcikTuru = 'A', onAbDegis = () => {}, onTurDegis = () => {},
  akilliDizgi = true, onAkilliDizgi = () => {}, sayfaHedefi = '', setSayfaHedefi = () => {},
}) {
  const kanitSinif = icerikSinif || kanit.sinif;
  const sonucFiyatli = !!(yayineviSonuc && yayineviSonuc.fiyatli);
  return (
    <div className="mt-2 space-y-3">
      <div className="flex flex-wrap items-center gap-2">
        <SecimKutusu checked={cevapAnahtariGoster} onChange={() => setCevapAnahtariGoster(!cevapAnahtariGoster)}
          title="Cevap anahtarı sayfası: kitapçığın sonuna öğretmen için cevap anahtarı eklenir (ÖSYM kitapçığında yoktur; ayrı sayfadır)">
          Cevap anahtarı sayfası
        </SecimKutusu>
        <SecimKutusu checked={cozumDosyasiAyri} onChange={() => setCozumDosyasiAyri(!cozumDosyasiAyri)}
          title="Çözüm sayfaları aynı PDF'in sonuna eklenir (soru sayfalarından ve cevap anahtarından sonra) — soru kitapçığıyla aynı numaralar, ÖSYM sayfa düzeni">
          Çözümler PDF’in sonunda
        </SecimKutusu>
        <SecimKutusu checked={yayineviTeslim} onChange={() => setYayineviTeslim(!yayineviTeslim)}
          title="Soruları sistemden düşür: alıcı (kurum, okul, yayınevi ya da kişi) listeden seçilir; PDF indirildiğinde basılan sorular o alıcıya satıldı olarak yazılır ve havuzdan düşer (birim fiyat girilirse satış, boşsa fiyat bekleyen teslim). Seçilmezse baskı DENEME BASKISIDIR; sorular havuzda kalır. Okul seçiliyse alıcı o okul olur. Yalnız PDF indirme kayıt yazar; yazdırma ve önizleme yazmaz. Başka alıcıya satılmış sorular kitapçığa giremez. Bağlam temelli soruların eksik kardeşleri kitapçığa otomatik eklenir (ayrı satılmazlar). Kayıtlar Satış Arşivi’ndedir.">
          🔒 Soruları sistemden düşür (satıldı kaydet)
        </SecimKutusu>
        {!yayineviTeslim && !yayinevi && <span className="text-[10px] text-gray-500">seçilmezse deneme baskısıdır; sorular havuzda kalır</span>}
        {!yayineviTeslim && yayinevi && (
          <span data-yeniden-basim className="text-[11px] text-purple-800">
            🔁 Yeniden basım: <strong>{yayinevi.ad}</strong> — bu yayınevine satılmış sorular basılır, yeni satış kaydı yazılmaz
            <button type="button" onClick={() => onYayineviSec(null)} aria-label="Yeniden basım yayınevini kaldır"
              className="ml-1 px-1.5 rounded hover:bg-purple-100">✕</button>
          </span>
        )}
        {yayineviTeslim && (
          <>
            <YayineviSecici apiUrl={apiUrl} authFetch={authFetch}
              value={yayinevi ? yayinevi.id : null} valueAd={yayinevi ? yayinevi.ad : ''}
              onChange={onYayineviSec} zorunlu etiket="" bosSecenek="Kurum / kişi seçin…" className="w-48" />
            <input data-birim-fiyat type="text" inputMode="decimal" value={birimFiyat}
              onChange={(e) => setBirimFiyat(e.target.value)}
              placeholder="Birim fiyat (₺)" maxLength={12}
              title="İsteğe bağlı. Girilirse PDF indirilince satış yazılır; boşsa kayıt “fiyat bekliyor” teslimi olur (Satış Arşivi’nden fiyatlandırılır)"
              className="px-2 py-1.5 rounded-lg border border-purple-200 text-xs w-32" />
            {teslimKilidi && (
              <span data-teslim-kilidi className="text-[11px] font-semibold text-red-700">⛔ PDF kilitli: {teslimKilidi}</span>
            )}
            {onYalnizKaydet && (
              <button type="button" data-yalniz-kaydet onClick={onYalnizKaydet}
                disabled={!!teslimKilidi || kayitAdet < 1 || kayitYaziliyor}
                title={kayitAdet < 1
                  ? 'Soru listesi belli değil — Seçili kanalda soru ekleyin ya da her dersi numara listesiyle doldurun'
                  : 'Daha önce basılmış soruları önizleme ve PDF üretmeden satıldı olarak kaydeder (PDF indirmeyle aynı kurallar; bağlam kardeşleri eklenir).'}
                className="px-2 py-1.5 rounded-lg border border-purple-300 bg-white text-purple-800 text-xs font-semibold hover:bg-purple-50 disabled:opacity-50 disabled:cursor-not-allowed">
                {kayitYaziliyor ? 'Kaydediliyor…' : `💾 PDF’siz kaydet${kayitAdet > 0 ? ` (${kayitAdet} soru)` : ''}`}
              </button>
            )}
          </>
        )}
      </div>

      {/* ÖSYM kapak seti TÜM ürünlerde (2026-09-04): tam deneme, genel deneme, tek dersli konu testi */}
      {!soruBankasi && <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="text-[10px] text-gray-500 font-bold uppercase" title="ÖSYM kapak setinde (kapak + açıklama + arka kapak) görünen kurum adı ve sınav tarihi — boş bırakılabilir; yayınevi seçilince adı buraya ön-dolar">Kapak</span>
        <YayineviSecici kaynak="okul" apiUrl={apiUrl} authFetch={authFetch}
          value={okul ? okul.id : null} valueAd={okul ? okul.ad : ''}
          onChange={setOkul} etiket="" bosSecenek="Okul seçilmedi" className="w-auto" />
        {okul && <OkulLogo apiUrl={apiUrl} authFetch={authFetch} okul={okul} setOkul={setOkul} />}
        {!okul && (
          <input type="text" value={kurum} onChange={e => setKurum(e.target.value)}
            placeholder="Kurum adı (isteğe bağlı)" maxLength={80}
            className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs w-56" />
        )}
        <input data-sinav-adi type="text" value={sinavAdi} onChange={e => setSinavAdi(e.target.value)}
          placeholder="Sınav adı (isteğe bağlı)" maxLength={SINAV_ADI_MAX} aria-label="Sınav adı"
          title="Kapakta büyük başlık satırına büyük harfle basılır (ör. “öğrenme çıktısı süreç izleme 1” → ÖĞRENME ÇIKTISI SÜREÇ İZLEME 1). Boş bırakılırsa ürünün adı (KONU TESTİ, GENEL DENEME, ÖĞRENME KANITI SINAVI, ÖSYM kimliği) basılır."
          className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs w-60" />
        <input type="date" value={sinavTarihi} onChange={e => setSinavTarihi(e.target.value)}
          title="Sınav tarihi (isteğe bağlı)"
          className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs" />
        <input data-sinav-suresi type="number" inputMode="numeric" min={SINAV_SURESI_MIN} max={SINAV_SURESI_MAX} step={1}
          value={sinavSuresi} onChange={e => setSinavSuresi(e.target.value)}
          placeholder="Süre (dk) · otomatik" aria-label="Sınav süresi (dakika)"
          title="Sınav süresi (dakika, isteğe bağlı). Kapakta, açıklama sayfasında ve arka kapakta basılır. Boş bırakılırsa ÖSYM oranından hesaplanır (TYT 165 dk/120 soru, AYT 180 dk/80 soru; 5'e yuvarlı, en az 30)."
          className={`px-2 py-1.5 rounded-lg border text-xs w-36 ${sinavSuresi !== '' && !sinavSuresiGecerli(sinavSuresi) ? 'border-red-400' : 'border-gray-300'}`} />
        {sinavSuresi !== '' && !sinavSuresiGecerli(sinavSuresi) && (
          <span data-sinav-suresi-uyari className="text-[11px] font-semibold text-red-700">süre {SINAV_SURESI_MIN}-{SINAV_SURESI_MAX} dk tam sayı olmalı · otomatik kullanılacak</span>
        )}
        {!tamDenemeAktif && kanitKapali && (
          <span data-kanit-kapali className="text-[11px] text-gray-500"
            title="Öğrenme Kanıtı 9, 10 ve 11. sınıf içindir; İçerik'te 12. sınıf seçili">
            📘 Öğrenme Kanıtı (12. sınıfta yok)
          </span>
        )}
        {!tamDenemeAktif && !kanitKapali && (
          <SecimKutusu checked={kanit.acik} onChange={() => setKanit({ ...kanit, acik: !kanit.acik })}
            title="Öğrenme Kanıtı: 9, 10 ve 11. sınıfta işlenen konuların denemesi. Kapakta “Türkiye Yüzyılı Maarif Modeli / ÖĞRENME KANITI SINAVI <uygulama no>” ve sınıf basılır; sorular seçtiğiniz ders ve öğrenme çıktılarından gelir.">
            📘 Öğrenme Kanıtı
          </SecimKutusu>
        )}
        {!tamDenemeAktif && !kanitKapali && kanit.acik && (
          <>
            {icerikSinif ? (
              <span className="text-[11px] text-gray-600" title="Sınıf, İçerik bölümündeki sınıf seçiminden gelir">{icerikSinif}. sınıf (içerikten)</span>
            ) : (
              <select data-kanit-sinif value={String(kanit.sinif)} onChange={e => setKanit({ ...kanit, sinif: Number(e.target.value) })}
                aria-label="Öğrenme Kanıtı sınıfı" className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs bg-white">
                {[9, 10, 11].map(n => <option key={n} value={String(n)}>{n}. sınıf</option>)}
              </select>
            )}
            {kanitSinif === 11 && (
              <select data-kanit-alan value={kanit.alan || ''} onChange={e => setKanit({ ...kanit, alan: e.target.value })}
                aria-label="Öğrenme Kanıtı alanı" className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs bg-white">
                <option value="">Alan yok</option>
                <option value="SAY">Sayısal</option>
                <option value="EA">Eşit Ağırlık</option>
              </select>
            )}
            <input data-kanit-uygulama type="number" min={1} max={20} value={kanit.uygulama}
              onChange={e => setKanit({ ...kanit, uygulama: e.target.value })}
              placeholder="Uygulama no" title="Kaçıncı uygulama (isteğe bağlı): kapakta “ÖĞRENME KANITI SINAVI 2”"
              className="px-2 py-1.5 rounded-lg border border-gray-300 text-xs w-28" />
          </>
        )}
        <span className="text-[10px] text-gray-500">
          {tamDenemeAktif ? 'ÖSYM kitapçık kimliği' : kanit.acik && !kanitKapali ? `Öğrenme Kanıtı (${kanitSinif}. sınıf) kimliği` : genelDeneme ? 'Genel deneme kimliği' : 'Konu testi kimliği (ders)'}
          {okul ? ' · okul kapağı (logo + karekod + öğrenci bilgileri + “MEBİ AYARINDA” mührü)' : ''}
        </span>
      </div>}

      {/* KAPAK TASARIMI (2026-10-12, Figma "DenemeKapak"): yalnız Konu Testi / Genel Deneme — tam deneme
          ÖSYM kimliğini taşır. Ön + arka kapak tasarımdan; AÇIKLAMA sayfası aynen. */}
      {/* LGS (2026-10-21): LGS tasarımları LGS oturum denemesinde de seçilir. */}
      {!soruBankasi && (!tamDenemeAktif || LGS_MODU) && (
        <div className="flex flex-wrap items-start gap-2 text-xs" data-kapak-tasarimlari>
          <span className="text-[10px] text-gray-500 font-bold uppercase pt-2" title={LGS_MODU
            ? 'Ön ve arka kapak görünümü. Başlık LGS; alt satıra sınav adı (boşsa “Deneme Sınavı”), oturum ve dersler ile soru sayıları kitapçıktan gelir.'
            : 'Ön ve arka kapak görünümü. Başlık “Öğrenme Çıktıları”; alt satıra sınav adı (boşsa “Kavrama Sınavı”), sınıf İçerik’teki sınıf seçiminden, dersler kitapçıktaki derslerden gelir.'}>Kapak tasarımı</span>
          {[{ id: '', ad: LGS_MODU ? 'Standart' : 'ÖSYM', aciklama: LGS_MODU ? 'Standart kitapçık kapağı (varsayılan)' : 'ÖSYM kitapçık kapağı (varsayılan)' }, ...kapakTasarimlari(LGS_MODU)].map((t) => (
            <button key={t.id || 'osym'} type="button" data-kapak-tasarim={t.id || 'osym'} aria-pressed={kapakTasarim === t.id}
              onClick={() => setKapakTasarim(t.id)} title={t.aciklama}
              className={`${secimSinifi(kapakTasarim === t.id)} inline-flex flex-col items-center gap-1`}>
              {t.id
                ? <img src={`${process.env.PUBLIC_URL || ''}/kapak/${t.id}.png`} alt="" className="w-14 h-[79px] object-cover rounded border border-gray-200 bg-white" />
                : <span className="w-14 h-[79px] rounded border border-gray-200 bg-gray-100 flex items-center justify-center text-[9px] text-gray-500 font-bold">ÖSYM</span>}
              <span>{kapakTasarim === t.id ? SECILI_ISARET : ''}{t.ad}</span>
            </button>
          ))}
        </div>
      )}

      {/* A/B KİTAPÇIK (okul denemesi, 2026-10-08): aynı sorular, iki sıra. Tür değişince önizleme
          AYNI listeyle yeniden derlenir; her tür ayrı PDF (ikinci dosya otomatik inmez). */}
      {!tamDenemeAktif && (
        <div className="flex flex-wrap items-center gap-2 text-xs" data-akilli-dizgi>
          <SecimKutusu checked={akilliDizgi} onChange={onAkilliDizgi}
            title="Sığan soru sütunda kalır ve sorular sayfaları dolduracak biçimde yeniden dizilir (uzun ve kısa sorular dengelenir); ders sırası, bağlam grupları, A/B ilk sayfaları ve cevap harfi kuralı korunur. Kapatılırsa sıra ve dizgi eskisi gibi.">
            Akıllı dizgi (sayfaları doldur)
          </SecimKutusu>
          {akilliDizgi && (
            <label className="inline-flex items-center gap-1 text-[11px] text-gray-600"
              title="Toplam PDF sayfası (kapak ve kurallar dahil). Aşılırsa soru arası boşluk kademeli daraltılıp yeniden dizilir. Boş bırakılırsa okul sınavında 24.">
              Sayfa hedefi
              <input type="number" min={4} max={400} step={4} data-sayfa-hedefi value={sayfaHedefi}
                onChange={(e) => setSayfaHedefi(e.target.value)} placeholder={soruBankasi ? 'yok' : 'okul: 24'}
                className="px-1.5 py-0.5 rounded border border-gray-300 text-[11px] w-16" />
            </label>
          )}
        </div>
      )}
      {!tamDenemeAktif && !soruBankasi && (
        <div className="flex flex-wrap items-center gap-2 text-xs" data-ab-kitapcik>
          <SecimKutusu checked={abKitapcik} onChange={() => onAbDegis(!abKitapcik)}
            title="A ve B kitapçığı: aynı sorular, farklı sıra. A kolaydan zora; B'de her testin ilk sayfalarındaki sorular A'nınkilerden farklı; iki kitapçıkta da aynı cevap harfi en çok 3 kez üst üste. Kapakta kitapçık türü basılır.">
            A/B kitapçık
          </SecimKutusu>
          {abKitapcik && ['A', 'B'].map(t => (
            <button key={t} type="button" data-kitapcik-turu={t} aria-pressed={kitapcikTuru === t}
              onClick={() => { if (t !== kitapcikTuru) onTurDegis(t); }}
              className={secimSinifi(kitapcikTuru === t)}>
              {kitapcikTuru === t ? SECILI_ISARET : ''}{t} kitapçığı
            </button>
          ))}
          {abKitapcik && <span className="text-[10px] text-gray-500">önizleme ve Yazdır seçili türle; PDF A ve B'yi birlikte indirir (zip: iki kitapçık + iki cevap anahtarı + öğrenme çıktısı Excel'i + sistem numaraları Excel'i)</span>}
        </div>
      )}

      {denemeKayit && (
        <div data-deneme-kayit
          className="rounded-lg border border-emerald-300 bg-emerald-50 p-2.5 text-[11px] text-emerald-900">
          📇 Deneme kaydedildi — kod <strong>{denemeKayit.kod.slice(0, 4)}-{denemeKayit.kod.slice(4)}</strong>
          {' '}({denemeKayit.kitapcik_turu} kitapçığı{denemeKayit.satildi ? ', sorular satıldı olarak düştü' : ', deneme baskısı'}).
          {denemeKayit.url && <> <a href={denemeKayit.url} target="_blank" rel="noreferrer" className="underline font-semibold">Karekod sayfası ↗</a></>}
          {denemeKayit.hata && <span className="text-red-700 font-semibold"> Kayıt yazılamadı: {denemeKayit.hata}</span>}
          {' '}Cevap anahtarı Satış Arşivi › Denemeler’den yayımlanır.
        </div>
      )}

      {yayineviSonuc && (
        <div data-yayinevi-sonuc
          className="rounded-lg border border-purple-300 bg-purple-50 p-2.5 text-[11px] text-purple-900 flex items-center justify-between gap-2">
          <div>
            📕 <strong>{yayineviSonuc.isaretlenen ?? 0}</strong> soru{' '}
            {yayineviSonuc.yayineviAd ? <strong>{yayineviSonuc.yayineviAd}</strong> : 'seçili alıcı'} adına sistemden düştü —{' '}
            {sonucFiyatli ? 'satış olarak yazıldı' : 'fiyat bekliyor'}
            {Number(yayineviSonuc.zaten_isaretli) > 0 && ` (${yayineviSonuc.zaten_isaretli} zaten kayıtlıydı)`}
            {Number(yayineviSonuc.fiyatlanan) > 0 && ` · ${yayineviSonuc.fiyatlanan} bekleyen teslim fiyatlandı`}.
            {yayineviSonuc.uyari && <span className="text-red-700 font-semibold"> {yayineviSonuc.uyari}</span>}
            {yayineviSonuc.hata && <span className="text-red-700 font-semibold"> {yayineviSonuc.hata}</span>}
          </div>
          <div className="flex gap-1.5 shrink-0">
            {onSatisArsivineGit && (
              <button type="button" onClick={() => onSatisArsivineGit(sonucFiyatli ? 'aktif' : 'teslim')}
                className="px-2 py-0.5 rounded bg-white border border-purple-300 hover:bg-purple-100 font-semibold">
                Satış Arşivi’nde gör
              </button>
            )}
            <button type="button" onClick={() => setYayineviSonuc(null)}
              className="px-2 py-0.5 rounded hover:bg-purple-100" aria-label="Şeridi kapat">✕</button>
          </div>
        </div>
      )}
    </div>
  );
}
